module.exports = __webpack_public_path__ + "static/media/bluepenTiac.620c6ee4.svg";